import type { CustomerPriority } from '@kalos/kalos-rpc';
import { addBusinessDays, addDays, addHours } from 'date-fns';

export const RESPONSE_TIME_UNITS = [
  { id: 1, label: 'Hours' },
  { id: 2, label: 'Business days' },
  { id: 3, label: 'Calendar days' },
] as const;

export const responseTimeUnitLabel = (unitTypeId: number): string =>
  RESPONSE_TIME_UNITS.find((u) => u.id === unitTypeId)?.label ?? '';

export const addResponseTime = (start: Date, amount: number, unitTypeId: number): Date => {
  switch (unitTypeId) {
    case 2:
      return addBusinessDays(start, amount);
    case 3:
      return addDays(start, amount);
    default:
      return addHours(start, amount);
  }
};

export const customerPriorityHint = (priority: CustomerPriority): string => {
  const base = `${priority.responseTime} ${responseTimeUnitLabel(priority.responseTimeUnitTypeId)}`;
  return priority.description ? `${base} / ${priority.description}` : base;
};
